var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-simple-tooltip',{attrs:{"content":_vm.$t('alarm.hasBookmark'),"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-icon',_vm._g({staticClass:"cursor-default",attrs:{"size":"22"}},on),[_vm._v(" bookmark ")])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }